export default __webpack_public_path__ + "static/media/social-media-x.8e49bc29.svg";